export let APP_SETTINGS = {
    version: '',
    church: 'graafschap',
};
